import { brand, alpha } from '@/styles/shared';
export const actionButtonsStyles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    gap: 2,
    mt: 2,
    mb: 3,
  },
  getNoteButton: {
    backgroundColor: brand.greenPrimary,
    color: 'white',
    fontSize: '12px',
    fontWeight: 600,
    padding: '8px 31px',
    borderRadius: '5px',
    '&:hover': {
      backgroundColor: brand.greenPrimaryDark,
    },
    '&:disabled': {
      backgroundColor: '#cccccc',
      color: '#666666',
    },
  },
  recordNewButton: {
    borderColor: brand.purpleAccent,
    color: brand.purpleAccent,
    fontSize: '12px',
    fontWeight: 600,
    padding: '8px 16px',
    borderRadius: '5px',
    '&:hover': {
      borderColor: brand.purpleAccentDark,
      color: brand.purpleAccentDark,
      backgroundColor: alpha.purple05,
    },
  },
};
